/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresentingConcernSectionDto
 */
export interface PresentingConcernSectionDto {
    /**
     * Unique identifier for this section (auto-generated if not provided)
     * @type {string}
     * @memberof PresentingConcernSectionDto
     */
    id?: string;
    /**
     * Primary health concerns text field - Max length: 255 characters
     * @type {string}
     * @memberof PresentingConcernSectionDto
     */
    primaryHealthConcerns?: string;
    /**
     * When did you first notice? text field - Max length: 255 characters
     * @type {string}
     * @memberof PresentingConcernSectionDto
     */
    whenFirstNoticed?: string;
    /**
     * Treatments tried text field - Max length: 255 characters
     * @type {string}
     * @memberof PresentingConcernSectionDto
     */
    treatmentsTried?: string;
}

/**
 * Check if a given object implements the PresentingConcernSectionDto interface.
 */
export function instanceOfPresentingConcernSectionDto(value: object): value is PresentingConcernSectionDto {
    return true;
}

export function PresentingConcernSectionDtoFromJSON(json: any): PresentingConcernSectionDto {
    return PresentingConcernSectionDtoFromJSONTyped(json, false);
}

export function PresentingConcernSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentingConcernSectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'primaryHealthConcerns': json['primaryHealthConcerns'] == null ? undefined : json['primaryHealthConcerns'],
        'whenFirstNoticed': json['whenFirstNoticed'] == null ? undefined : json['whenFirstNoticed'],
        'treatmentsTried': json['treatmentsTried'] == null ? undefined : json['treatmentsTried'],
    };
}

export function PresentingConcernSectionDtoToJSON(json: any): PresentingConcernSectionDto {
    return PresentingConcernSectionDtoToJSONTyped(json, false);
}

export function PresentingConcernSectionDtoToJSONTyped(value?: PresentingConcernSectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'primaryHealthConcerns': value['primaryHealthConcerns'],
        'whenFirstNoticed': value['whenFirstNoticed'],
        'treatmentsTried': value['treatmentsTried'],
    };
}

